import { supabase } from './supabaseClient.js';
import { fetchCatalog } from './catalogRepo.js';
import { fetchCodigosParo } from './parosRepo.js';

/**
 * Suscripción en tiempo real a cambios en el catálogo (tablas `skus` y
 * `sku_lineas`). Ante cualquier INSERT/UPDATE/DELETE, se vuelve a pedir el
 * catálogo completo (120 SKUs es un dataset pequeño; un refetch simple es
 * más robusto que reconciliar parches JSON a mano) y se notifica al
 * callback para refrescar la UI en todos los dispositivos conectados.
 *
 * Devuelve una función `unsubscribe()` para limpiar el canal.
 */
export function subscribeToCatalogChanges(onChange) {
  let debounceTimer = null;
  const triggerRefresh = () => {
    clearTimeout(debounceTimer);
    // pequeño debounce: un cambio de SKU suele tocar 1-3 filas de sku_lineas casi a la vez
    debounceTimer = setTimeout(async () => {
      try {
        const data = await fetchCatalog();
        onChange(data);
      } catch (err) {
        console.error('[realtime] error al refrescar catálogo tras cambio:', err);
      }
    }, 300);
  };

  const channel = supabase
    .channel('catalogo-realtime')
    .on('postgres_changes', { event: '*', schema: 'public', table: 'skus' }, triggerRefresh)
    .on('postgres_changes', { event: '*', schema: 'public', table: 'sku_lineas' }, triggerRefresh)
    .subscribe();

  return () => {
    clearTimeout(debounceTimer);
    supabase.removeChannel(channel);
  };
}

/**
 * Suscripción en tiempo real a cambios en el maestro de códigos de parada
 * (tabla `codigos_paro`) — mismo patrón que subscribeToCatalogChanges.
 */
export function subscribeToParosChanges(onChange) {
  let debounceTimer = null;
  const triggerRefresh = () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(async () => {
      try {
        const data = await fetchCodigosParo();
        onChange(data);
      } catch (err) {
        console.error('[realtime] error al refrescar códigos de parada tras cambio:', err);
      }
    }, 300);
  };

  const channel = supabase
    .channel('paros-realtime')
    .on('postgres_changes', { event: '*', schema: 'public', table: 'codigos_paro' }, triggerRefresh)
    .subscribe();

  return () => {
    clearTimeout(debounceTimer);
    supabase.removeChannel(channel);
  };
}
